"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _systemForm = require("@/api/systemForm");
var _reservation = require("@/api/reservation");
var _useProduct2 = require("@/hooks/use-product");
var _DrawGeometryMap = _interopRequireDefault(require("./DrawGeometryMap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'LabelList',
  data: function data() {
    return {
      activeName: '1',
      type: 1,
      clockVisible: false,
      form: {
        serviceEvidenceFormId: null,
        clockInDistance: 1,
        vieSwitch: true,
        clockInPhotoSwitch: true,
        clockInAddressSwitch: false,
        serviceEvidenceSwitch: false,
        clockInType: 1,
        clockInTypeBtn: false,
        serviceAreaSwitch: false,
        serviceAreaRange: ''
      },
      rules: {
        clockInDistance: [{
          required: true,
          message: '请输入打卡范围',
          trigger: 'change'
        }],
        serviceEvidenceFormId: [{
          required: true,
          message: '请选择关联表单',
          trigger: 'change'
        }]
      },
      formUrl: '',
      systemFormList: [],
      tableData: [{
        name: '用户预约',
        status: true,
        disable: true,
        info: '  用户预约为必要节点，不可关闭'
      }, {
        name: '抢单',
        key: 'vieSwitch',
        info: "\u62A2\u5355\u5F00\u542F\uFF0C\u670D\u52A1\u4EBA\u5458\u53EF\u4EE5\u62A2\u5355"
      }, {
        name: '上门打卡',
        key: 'clockInTypeBtn',
        info: '上门打卡关闭之后，则无需开始服务直接进入下一环节',
        type: 1,
        action: '上门打卡范围'
      }, {
        name: '服务过程留凭',
        key: 'serviceEvidenceSwitch',
        info: '服务过程留凭根据关联系统表单填写提交，服务过程选填可跳过，关闭则直接进入下一环节',
        action: '关联系统表单',
        type: 2
      }, {
        name: '结束服务',
        status: true,
        disable: true,
        info: '服务人员结束服务'
      }]
    };
  },
  components: {
    DrawGeometryMap: _DrawGeometryMap.default
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:system:form:page'])) this.getFormList();
    if ((0, _permission.checkPermi)(['admin:merchant:reservation:to:home:info'])) this.getInfo();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 回调地图绘制后得到坐标数组
    getServiceAreaRange: function getServiceAreaRange(val) {
      this.form.serviceAreaRange = JSON.stringify(val);
      this.saveDate();
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    typeChange: function typeChange(val) {
      if (this.form.clockInAddressSwitch) {
        this.form.clockInDistance = 1;
      } else {
        this.form.clockInDistance = 500;
      }
    },
    // 表格操作
    open: function open(row) {
      this.type = row.type;
      if (row.type == 1) {
        this.clockVisible = true;
      } else {
        this.clockVisible = true;
      }
    },
    //详情
    getInfo: function getInfo() {
      var _this = this;
      (0, _reservation.reservationHomeInfoApi)().then(function (res) {
        _this.form = _objectSpread(_objectSpread({}, res), {}, {
          clockInTypeBtn: res.clockInType === 2 ? true : false,
          serviceEvidenceFormId: res.serviceEvidenceFormId || null
        });
      });
    },
    // 保存
    handleSave: function handleSave() {
      this.saveDate();
    },
    //  提交数据调接口
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.saveDate();
          _this2.clockVisible = false;
        }
      });
    },
    // 调取接口
    statusChange: function statusChange(row) {
      if (row.key === 'serviceEvidenceSwitch' && this.form.serviceEvidenceSwitch && !this.form.serviceEvidenceFormId) {
        this.form.serviceEvidenceSwitch = !this.form.serviceEvidenceSwitch;
        return this.$message.warning('开启服务过程留凭请先关联系统表单！');
      }
      this.saveDate();
    },
    // 保存数据
    saveDate: function saveDate() {
      var _this3 = this;
      this.form.clockInType = this.form.clockInTypeBtn ? 2 : 1;
      (0, _reservation.reservationHomeEditApi)(this.form).then(function (res) {
        _this3.$message.success('保存成功');
      });
    },
    // 系统表单下拉数据
    getFormList: function () {
      var _getFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _systemForm.systemFormPageApi)({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context.v;
              list = _yield$systemFormPage.list;
              this.systemFormList = list;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getFormList() {
        return _getFormList.apply(this, arguments);
      }
      return getFormList;
    }()
  }
};